import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AgentAuthApi } from '../apis/agent-auth-api';

export interface AgentAuthService {
    checkDocumentAnalyzerPermission(agentId: string): Promise<boolean>;
}

export const AgentAuthService = Symbol('AgentAuthService');

@injectable()
export class AgentAuthServiceImpl implements AgentAuthService {
    constructor(
        @inject(AgentAuthApi) private agentAuthApi: AgentAuthApi
    ) {}

    async checkDocumentAnalyzerPermission(agentId: string): Promise<boolean> {
        try {
            const res = await this.agentAuthApi.checkDocumentAnalyzerAuth({ id: agentId });
            return res;
        } catch (error) {
            console.error('[AgentAuthService] checkDocumentAnalyzerPermission error:', error);
            return false;
        }
    }
}
